



















import { defineComponent } from 'vue';

import { Poll } from '@/modules/polls/dist/types';

import { pollsStoreMapper } from '@/modules/polls/dist/store';
import { appStoreMapper } from '@/store/appstore';

export default defineComponent({
  name: 'ProfilePollsFields',
  computed: {
    registrationPoll(): Nullable<Poll> {
      return this.polls.find((p) => p.placement === 'registration');
    },
    ...appStoreMapper.mapGetters(['user']),
    ...pollsStoreMapper.mapGetters(['polls']),
  },
  methods: {
    getUserAnswer(poll: Nullable<Poll>, idField: number): Nullable<string> {
      return this.user?.pollAnswers?.find(
        (a) => a.idPoll === poll?.id && a.idPollField === idField,
      )?.value;
    },
  },
});
